import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import api from '@/axios';
import { GET_PRODUCTION_DECLARATION_COMMODITY_ORIGIN_PRODUCTION_PLACES_KEY } from '@/keys';
import type {
  ProductionPlace,
  ProductionPlaceCoordinates,
} from '@/types/core/production-declaration/production-place';

type UpdateProductionPlaceVariables = {
  productionDeclarationId: string;
  materialId: string;
  commodityOriginId: string;
  productionPlaceId: string;
  coordinates: ProductionPlaceCoordinates;
  countryId: number;
  description: string;
  forestTypeId: number;
  productionTimeRange: string;
  token?: string;
};

async function updateProductionPlace({
  productionDeclarationId,
  materialId,
  commodityOriginId,
  productionPlaceId,
  token,
  ...payload
}: UpdateProductionPlaceVariables): Promise<ProductionPlace> {
  const response = await api.patch<ProductionPlace>(
    `/production-declarations/${productionDeclarationId}/materials/${materialId}/commodity-origins/${commodityOriginId}/production-places/${productionPlaceId}`,
    payload,
    {
      params: token ? { token } : undefined,
    },
  );

  return response.data;
}

export function useUpdateProductionPlace(): UseMutationResult<
  ProductionPlace,
  Error,
  UpdateProductionPlaceVariables
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateProductionPlace,
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: [
          ...GET_PRODUCTION_DECLARATION_COMMODITY_ORIGIN_PRODUCTION_PLACES_KEY,
          variables.productionDeclarationId,
          variables.materialId,
          variables.commodityOriginId,
          variables.token ?? '',
        ],
      });
    },
  });
}
